import axios from 'axios';
import { BASE_URL } from 'app/utils/apiConfig';
import { store } from 'app/redux/Store';
import { userLoggedOut } from 'app/redux/auth/authSlice';
import { clearActiveClient } from 'app/redux/client/activeClientSlice';
export { BASE_URL } from 'app/utils/apiConfig';
const api = axios.create({
  baseURL: BASE_URL,
});

// Add a request interceptor to include the Bearer token from 'auth_user'
api.interceptors.request.use(
  (config) => {
    const authDataRaw = localStorage.getItem('auth_user');
    let token;
    if (authDataRaw) {
      try {
        const authData = JSON.parse(authDataRaw);
        token = authData?.accessToken;
      } catch (e) {
        token = undefined;
      }
    }
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add a response interceptor to handle expired/invalid sessions or account blocked
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const errorData = error?.response?.data;
    const errorCode = errorData?.code || errorData?.errorCode;
    const errorMsg = typeof errorData === 'string' ? errorData : (errorData?.message || '');

    const isAccountBlocked =
      errorCode === 'ACCOUNT_BLOCKED' ||
      (typeof errorMsg === 'string' &&
        (errorMsg.toLowerCase().includes('suspendu') ||
          errorMsg.toLowerCase().includes('bloqu')));

    if (isAccountBlocked) {
      const displayMsg =
        typeof errorMsg === 'string' && errorMsg && !errorMsg.includes('Forbidden')
          ? errorMsg
          : 'Ce compte a été suspendu par un administrateur.';

      try {
        sessionStorage.setItem('blocked_account_message', displayMsg);
      } catch (e) {
        // ignore storage errors
      }

      // If global security modal handler is active, trigger it so the modal can be viewed on the current page
      if (typeof window !== 'undefined' && typeof window.__handleForcedLogout === 'function') {
        window.__handleForcedLogout(displayMsg);
      } else {
        const currentPath = window.location.pathname || '';
        if (!currentPath.startsWith('/sessions')) {
          setTimeout(() => {
            window.location.href = '/sessions/signin?blocked=1';
          }, 3500);
        }
      }
    } else if (status === 401 || status === 403) {
      // If modal countdown is already handling termination, suppress hard redirect
      if (typeof window !== 'undefined' && window.__isTerminatingSession) {
        return Promise.reject(error);
      }

      try {
        // Clear auth state & localStorage
        store.dispatch(userLoggedOut());
        store.dispatch(clearActiveClient());
        localStorage.removeItem('auth_user');
      } catch (e) {
        // ignore dispatch errors
      }

      // Redirect to login if not already on a session route
      const currentPath = window.location.pathname || '';
      if (!currentPath.startsWith('/sessions/')) {
        window.location.href = '/sessions/signin';
      }
    }

    return Promise.reject(error);
  }
);

export default api;
